var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{attrs:{"head":_vm.tableHead,"card-view":"lgAndDown"}},_vm._l((_vm.items),function(item){return _c('WorkClientContactTableItem',{key:item.id,attrs:{"item":item,"type":_vm.type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }